import React, { useState } from 'react';
import Vimeo from '@u-wave/react-vimeo';
const TEMP_VIDEOS = [
    { videoId: 650409878, title: '' },
    { videoId: 650409929, title: '' },
    { videoId: 650409799, title: '' },
    { videoId: 650409771, title: '' },
    { videoId: 657215530, title: '' },
    { videoId: 654282388, title: '' },
    { videoId: 655525276, title: '' },
    { videoId: 654244473, title: '' },
    { videoId: 657209084, title: '' },
    { videoId: 745192263, title: '' },
    { videoId: 768479710, title: '' },
    { videoId: 768479813, title: '' }
];

const InAppVideosPage = () => {
    const [videos, setVideos] = useState(TEMP_VIDEOS);

    const onReady = (videoId: number) => (player: any) => {
        player.getVideoTitle().then((title: string) => {
            const videosWithTitle = videos.map((video) => {
                if (video.videoId === videoId) {
                    video.title = title;
                }

                return video;
            });

            setVideos(videosWithTitle);
        });
    };

    return (
        <div className='in-app-videos'>
            {videos?.map((video) => {
                return (
                    <div className='in-app-videos__video-block'>
                        <Vimeo
                            className='in-app-videos__video'
                            onReady={onReady(video.videoId)}
                            video={video.videoId}
                            width='315px'
                            height='175px'
                            background={false}
                            showPortrait={false}
                            showByline={false}
                            showTitle={false}
                        />
                        <div className='in-app-videos__video-context'>
                            <div className='in-app-videos__video-title'>{video.title}</div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default InAppVideosPage;
